import AppStore from "AppStore";
import colors from "config/colors";
import { webStyle } from "config/web-style";
import { Box, ScrollView, VStack } from "native-base";
import React, { useEffect, useState } from "react";
import { LoadingAnimation } from "widgets";
import { getGalleryVideos } from "./actions";
import VideosList from "./videos-list";

const Videos = () => {
  const [isBigScreen] = AppStore("isBigScreen");
  const [loading, setLoading] = useState(true);

  const [videos, setVideos] = useState<any>([]);

  useEffect(() => {
    setLoading(true);
    getGalleryVideos((error: any, res: any) => {
      if (!error) {
        setVideos(res);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  }, []);

  return (
    <Box flex="1" bg={isBigScreen ? colors.webOuterBg : colors.appInnerBg}>
      <ScrollView
        py={isBigScreen ? "0" : "4"}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={isBigScreen ? { paddingBottom: 0 } : { paddingBottom: 50 }}
      >
        <VStack space={4} mx={isBigScreen ? webStyle.xNum : 0} bg={isBigScreen ? colors.webInnerBg : colors.appInnerBg}>
          <VideosList videos={videos} />
        </VStack>
      </ScrollView>
      <LoadingAnimation loading={loading} />
    </Box>
  );
};

export default Videos;
